// extracted by mini-css-extract-plugin
export default {"titleLeftText":"Lists_titleLeftText__f1SLX","titleRightText":"Lists_titleRightText__rC2zZ"};